import Link from '../../views/RDownload';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';
import { saveAs } from 'file-saver';

const fileSaver = require('file-saver');

const mapStateToProps = (state, ownProps) => ({
  intl: ownProps.match.params.intl,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  reference_id: state.shift.assessment.reference_id,
  clientname: state.shift.assessment.clientname,
  username:state.shift.auth.username,
  srclang: state.shift.assessment.srclang,
  description: state.shift.assessment.description
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;
  return {
    getRptInfobyreferenceid: refid => {
      console.log('I am approbe:');
      dispatch(actions.getRptInfobyreferenceid(refid));
    },

    getinfobyusernameandreferenceid: (username, refid)  => {
      console.log(username);
      dispatch(actions.getinfobyusernameandreferenceid(username,refid));
    },

    clickBackHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/shift`));
    },
    clickSubmitHandler: reference_id => {
      dispatch(actions.downloadRpt(reference_id)).then(({ value }) => {
        fileSaver.saveAs(value.data, `Analyzer-Report-${reference_id}.pdf`);
      });
    }
  };
};

const RDownload = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default RDownload;



// WEBPACK FOOTER //
// ./src/components/container/RDownload/index.js